var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWomanStaring = function SvgWomanStaring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 206 224"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEDF4",
    d: "M188.229 113.566 28.482 100.881a9.873 9.873 0 0 0-10.627 9.064l-7.1 89.414a9.877 9.877 0 0 0 9.063 10.627l159.746 12.686a9.876 9.876 0 0 0 10.628-9.064l7.1-89.414a9.874 9.874 0 0 0-9.063-10.628",
    opacity: 0.87,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M183.125 100.375 21.613 87.549a9.44 9.44 0 0 0-10.16 8.665l-7.577 95.42a9.44 9.44 0 0 0 8.665 10.16l161.511 12.826a9.443 9.443 0 0 0 10.161-8.666l7.577-95.419a9.444 9.444 0 0 0-8.665-10.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    d: "m86.37 164.624-58.518-4.647a4.246 4.246 0 0 0-4.57 3.897l-1.852 23.322a4.247 4.247 0 0 0 3.897 4.569l58.519 4.647a4.246 4.246 0 0 0 4.57-3.897l1.851-23.322a4.247 4.247 0 0 0-3.897-4.569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.393,
    d: "m81.227 156.554-53.177-4.223a5.492 5.492 0 0 0-5.329 2.979 5.5 5.5 0 0 0-.583 2.063l-1.93 24.296a5.496 5.496 0 0 0 5.043 5.912l53.177 4.223a5.494 5.494 0 0 0 5.912-5.042l1.93-24.296a5.494 5.494 0 0 0-5.043-5.912Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.346,
    d: "m16.254 99.849 145.52 11.555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    d: "m87.894 119.038-60.351-4.792a2.73 2.73 0 0 0-2.658 1.486 2.737 2.737 0 0 0 1.195 3.686c.32.164.67.263 1.029.291l60.351 4.793a2.742 2.742 0 0 0 .434-5.464m-.861 10.846-60.351-4.792a2.737 2.737 0 0 0-2.95 2.515 2.74 2.74 0 0 0 2.516 2.949l60.351 4.792a2.737 2.737 0 0 0 2.949-2.515 2.74 2.74 0 0 0-2.515-2.949m-.967 12.172-60.351-4.792a2.74 2.74 0 1 0-.434 5.463l60.351 4.793a2.742 2.742 0 0 0 .434-5.464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#99C8DC",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.387,
    d: "m46.059 163.866-16.243-1.29a2.537 2.537 0 0 0-2.73 2.328l-1.09 13.734a2.54 2.54 0 0 0 2.328 2.73l16.242 1.289a2.536 2.536 0 0 0 2.73-2.328l1.09-13.734a2.54 2.54 0 0 0-2.328-2.729Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m27.88 181.128 4.533-5.587 5.177 2.854 10.364-7.547"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M37.14 171.963a2.477 2.477 0 1 0 .39-4.938 2.477 2.477 0 0 0-.39 4.938Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.387,
    d: "M191.233 113.689 11.221 99.394l.111-1.406C12.06 88.832 16.35 87.26 22.78 87.77L184 100.574a8.14 8.14 0 0 1 7.485 8.569z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m122.037 123.029 43.926 3.488m-44.382 2.253 21.219 1.685m-21.675 4.056 43.926 3.488m-44.383 2.259 33.303 2.645"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#99C8DC",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M35.73 31.47S23.74 47.387 15.317 58.776c-11.375 15.387.416 29.973 33.212 32.578l53.31 4.689-2.904 16.346 18.953 1.253.079.04s23.533 4.339 24.185-13.213c.619-17.05-16.071-45.608-46.142-48.759-30.072-3.15-40.357.402-40.357.402l4.637-8.43z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.611,
    d: "M55.357 51.905 43.008 69.794"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "m69.114 63.429-15.94 40.991 27.259 2.417L96.237 66.08z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.611,
    d: "M40.477 90.53s6.594 1.204 11.284.665m52.019-5.443 13.642 1.124"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE8DE",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "m103.773 85.752-4.155 22.159s-8.013-4.835-14.886-6.381-13.947-3.108-17.931-6.922-4.654-7.378-2.51-8.671c0 0-2.53-4.726 1.96-5.914 0 0-.504-6.164 5.07-3.87 0 0 1.257-4.174 5.936-.707 4.678 3.468 8.748 6.887 11.675 5.078s3.202-5.19 4.565-6.762 2.392-2.103 4.576-1.494 2.628 2.808 1.797 5.47c-.83 2.663-2.083 7.382 3.903 8.014Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.611,
    d: "M71.328 76.153s-1.087 6.664 10.657 10.876M66.25 80.023s-1.163 6.842 11.63 11.811m-13.59-5.897s.222 4.23 8.325 8.276"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE8DE",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "m76.153 50.528 1.176-9.5s-10.08 1.24-7.424-11.478c2.115-10.094 9.317-9.698 9.317-9.698s6.193 8.467 9.545 9.359c0 0 4.988-2.83 7.127 1.001 3.251 5.756-3.12 7.15-4.757 7.373L89.73 51.797s-.817 4.97-7.463 4.17c-7.065-.84-6.114-5.439-6.114-5.439Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "M90.556 45.16s9.545-5.278 9.26-14.378c-.284-9.1-6.393-17.52-20.223-15.093-4.526.784-6.539 2.482-8.09 5.734a1.36 1.36 0 0 0 .446 1.839l8.346-1.753 9.023 10.706s2.27-4.42 5.558-2.03c2.663 1.94.646 7.537-4.246 7.108z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "M96.788 21.614a6.634 6.634 0 1 0 1.05-13.226 6.634 6.634 0 0 0-1.05 13.226"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE8DE",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "M35.73 31.47s7.791-8.064 10.636-11.928S52.88 7.716 54.364 5.887s2.837-1.959 4.016-1.722c1.178.236 4.322 2.384-.758 8.684 0 0 6.353-4.504 8.622.684 0 0 5-2.563 6.34 3.607 0 0 6.743 2.162 5.768 5.609-.974 3.447-6.599-.45-6.599-.45s-1.346 1.867-3.001 1.382a2.68 2.68 0 0 1-1.879-2.055s-3.637.555-3.378 3.468 3.417 2.993 5.195 3.134c2.245.179 4.361 1.122 3.963 3.486-.4 2.364-2.848 2.952-5.983 2.417-3.136-.535-5.67-.07-10.444 7.867z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE8DE",
    d: "M55.397 16.272s.451-1.563 2.957-4.236z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "M55.397 16.272s.451-1.563 2.957-4.236"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE8DE",
    d: "M66.246 13.5s.871 1.117.636 3.643-2.197 3.425-3.718 2.869a4.61 4.61 0 0 1-3.004-3.73"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "M66.246 13.5s.871 1.117.636 3.643-2.197 3.425-3.718 2.869a4.61 4.61 0 0 1-3.004-3.73"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE8DE",
    d: "M72.588 17.106s.276 3.288-.832 5.16-2.487 1.674-3.002 1.381-2.644-.972-2.433-4.915"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "M72.588 17.106s.276 3.288-.832 5.16-2.487 1.674-3.002 1.381-2.644-.972-2.433-4.915"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.529,
    d: "M75.02 26.894c.503-1.676-.157-3.355-1.473-3.75s-2.792.642-3.295 2.318c-.503 1.675.155 3.355 1.473 3.75 1.317.395 2.791-.643 3.295-2.318Zm6.443 2.956c.503-1.675-.162-3.356-1.486-3.753s-2.805.638-3.309 2.313c-.503 1.677.164 3.357 1.488 3.755s2.805-.639 3.307-2.315Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#131416",
    d: "M77.33 41.007s2.327.273 5.477-2.287c0 0-3.573 6.52-6.108 8.36zm13.279-3.71s-4.045 3.375-5.85 10.608c-1.807 7.232 5.768 14.931 14.526 14.585 10.771-.417 18.809-5.93 15.232-14.44-3.577-8.512-15.572-5.96-15.012-14.122.202-2.712-2.349 6.612-8.896 3.37m13.171 48.455-8.736 19.686 4.61 2.272z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    d: "M11.613 95.308s-.19-8.568 9.175-7.825l37.604 2.987-.139 1.744"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.353,
    d: "M11.613 95.308s-.19-8.568 9.175-7.825l37.604 2.987-.139 1.744"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#E35205",
    d: "M21.433 97.02a3.263 3.263 0 1 0 .516-6.505 3.263 3.263 0 0 0-.517 6.506M44.302 98.837a3.263 3.263 0 1 0 .517-6.505 3.263 3.263 0 0 0-.517 6.505"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.387,
    d: "M33.78 99.022a3.616 3.616 0 1 0 .573-7.21 3.616 3.616 0 0 0-.572 7.21Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.611,
    d: "M141.91 76.79s5.036 8.137 5.524 16.137"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    d: "M74.362 166.317 57.775 165a1.425 1.425 0 0 0-1.533 1.307l-.022.277a1.424 1.424 0 0 0 1.307 1.533l16.587 1.317a1.423 1.423 0 0 0 1.533-1.307l.022-.277a1.425 1.425 0 0 0-1.307-1.533m-.589 7.411-16.587-1.317a1.425 1.425 0 0 0-1.533 1.307l-.022.278a1.424 1.424 0 0 0 1.307 1.532l16.588 1.318a1.425 1.425 0 0 0 1.533-1.308l.022-.277a1.425 1.425 0 0 0-1.308-1.533M61 180.165l-4.267-.339a1.56 1.56 0 0 0-1.678 1.432l-.001.007a1.56 1.56 0 0 0 1.432 1.679l4.267.338a1.557 1.557 0 0 0 1.678-1.431v-.007a1.56 1.56 0 0 0-1.43-1.679"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.529,
    d: "m75.008 26.567 2.034.95m14.682 6.454 2.999-1.858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E35205",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "M137.473 199.848c10.476.831 19.642-6.986 20.474-17.462s-6.986-19.642-17.462-20.474c-10.475-.831-19.642 6.986-20.473 17.462-.832 10.476 6.985 19.642 17.461 20.474Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.549,
    d: "m120.162 177.657 18.408 2.21 15.026-11.844s-8.691-11.122-23.317-4.574c-9.634 4.352-10.117 14.208-10.117 14.208Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#99C8DC",
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.583,
    d: "m138.332 180.209 1.477-18.609s6.934-.504 13.549 6.765z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#131416",
    strokeMiterlimit: 10,
    strokeWidth: 0.611,
    d: "m75.567 28.428-4.174 5.609 2.657.816m-.73 2.861a7.36 7.36 0 0 0 5.647-2.572"
  })));
};
export default SvgWomanStaring;